export default "__VITE_ASSET__985f9e21__"